/**
 * @generated SignedSource<<4518eccf415b988487fd9b9c42bdac8a>>
 * @relayHash de7a43373a3014228253ee55d82f9e68
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID de7a43373a3014228253ee55d82f9e68

import { ConcreteRequest } from 'relay-runtime';
export type DeletePersonalTreatmentPlanTemplateInput = {
  id: string;
};
export type useDeletePersonalTreatmentPlanTemplateMutation$variables = {
  input: DeletePersonalTreatmentPlanTemplateInput;
};
export type useDeletePersonalTreatmentPlanTemplateMutation$data = {
  readonly deletePersonalTreatmentPlanTemplate: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly treatmentPlanTemplate: {
      readonly name: string;
    } | null;
  };
};
export type useDeletePersonalTreatmentPlanTemplateMutation = {
  response: useDeletePersonalTreatmentPlanTemplateMutation$data;
  variables: useDeletePersonalTreatmentPlanTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeletePersonalTreatmentPlanTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeletePersonalTreatmentPlanTemplatePayload",
        "kind": "LinkedField",
        "name": "deletePersonalTreatmentPlanTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreatmentPlanTemplate",
            "kind": "LinkedField",
            "name": "treatmentPlanTemplate",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeletePersonalTreatmentPlanTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeletePersonalTreatmentPlanTemplatePayload",
        "kind": "LinkedField",
        "name": "deletePersonalTreatmentPlanTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreatmentPlanTemplate",
            "kind": "LinkedField",
            "name": "treatmentPlanTemplate",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "de7a43373a3014228253ee55d82f9e68",
    "metadata": {},
    "name": "useDeletePersonalTreatmentPlanTemplateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ed8448e8f0559020f919a14f38f756c5";

export default node;
